import React, { Fragment } from 'react'
import {
    TextField,
} from '@material-ui/core'
import Dropdown from 'shared/components/Dropdown';

const classes = {
    fullWidth: {
        width: '100%',
    },
}

const MultiRow = (props) => {
    const { data, handleChange } = props;

    return (
        data.map((obj, i) => {
            const { value, name, label, type, dropDown, menuItems } = obj;

            const Fields = dropDown ? (
                <Dropdown
                    data={{
                        value,
                        name,
                        menuItems,
                    }}
                    handleChange={handleChange}
                    normal
                    margin
                />
            ) : (
                <TextField
                    name={name}
                    label={label}
                    style={classes.fullWidth}
                    value={value}
                    onChange={handleChange}
                    type={type || 'text'}
                    margin="normal"
                    variant="outlined"
                />
            );

            return (
                <Fragment key={i}>
                    {name !== 'city' && name !== 'state' && (
                        <div className="row">
                            <div className="col">
                                {Fields}
                            </div>
                        </div>
                    )}
                </Fragment>
            )
        })
    )
}

const SameRow = (props) => {
    const { data, handleChange } = props;

    return (
        <div className="row">
            {data.map((obj, i) => {
                const { value, name, label, type, dropDown, menuItems } = obj;

                const Fields = dropDown ? (
                    <Dropdown
                        data={{
                            value,
                            name,
                            menuItems,
                        }}
                        handleChange={handleChange}
                        normal
                        margin
                    />
                ) : (
                    <TextField
                        name={name}
                        label={label}
                        style={classes.fullWidth}
                        value={value}
                        onChange={handleChange}
                        type={type || 'text'}
                        margin="normal"
                        variant="outlined"
                    />
                );

                return (
                    <Fragment key={i}>
                        {name === 'city' && (
                            <div className="col-8">
                                {Fields}
                            </div>
                        )}
                        {name === 'state' && (
                            <div className="col-4">
                                {Fields}
                            </div>
                        )}
                    </Fragment>
                );

            })}
        </div>
    );
}

const Inputs = (props) => {
    const { data, handleChange } = props;

    return (
        <Fragment>
            <MultiRow
                data={data}
                handleChange={handleChange}
            />
            <SameRow
                data={data}
                handleChange={handleChange}
            />
        </Fragment>
    )
}

export default Inputs